import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
// import { ArrowLeft } from '@outdoor-voices/ui';
import { KEY_CODES, KEY_DOWN } from '@outdoor-voices/ui/dist/config/constants';
import { useEffect, useRef } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { QUESTIONS, REVIEWS } from './constants';
import Button from '../../../components/Button';
import css from './Header.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var Header = function Header(_ref) {
  var active = _ref.active,
      setActive = _ref.setActive;
  var tablistRef = useRef(null); // auto-scroll to #questions if hash present

  useEffect(function () {
    var hash = window.location.hash || '';

    if (hash && hash === '#questions') {
      setActive(QUESTIONS);
    }
  }, [setActive]);
  useEffect(function () {
    var current = tablistRef.current;

    var onKeyDown = function onKeyDown(event) {
      var ARROW_LEFT = KEY_CODES.ARROW_LEFT,
          ARROW_RIGHT = KEY_CODES.ARROW_RIGHT;

      var tabElements = _toConsumableArray(current.querySelectorAll('button'));

      var tabFocus = tabElements.indexOf(document.activeElement);

      switch (event.key) {
        case ARROW_LEFT:
          tabFocus--; // If we're at the start, move to the end

          if (tabFocus < 0) {
            tabFocus = tabElements.length - 1;
          }

          break;

        case ARROW_RIGHT:
          tabFocus++; // If we're at the end, go to the start

          if (tabFocus >= tabElements.length) {
            tabFocus = 0;
          }

          break;

        default:
          break;
      }

      tabElements[tabFocus].setAttribute('tabindex', 0);
      tabElements[tabFocus].focus();
    };

    current.addEventListener(KEY_DOWN, onKeyDown);
    return function () {
      current.removeEventListener(KEY_DOWN, onKeyDown);
    };
  }, [tablistRef]);
  return /*#__PURE__*/_jsx("div", {
    "aria-label": "Reviews and Questions tabs",
    className: css.tabList,
    ref: tablistRef,
    role: "tablist",
    children: [REVIEWS, QUESTIONS].map(function (type) {
      var selected = type.id === active.id;
      return /*#__PURE__*/_jsx(Button, {
        "aria-controls": "type-".concat(type.id),
        "aria-label": "Click to display the ".concat(type.title, " panel"),
        "aria-selected": selected ? 'true' : 'false',
        className: cc([css.tab, css.title, _defineProperty({}, css.on, selected)]),
        linkStyle: true,
        onClick: function onClick() {
          setActive(type);
        },
        role: "tab",
        tabIndex: selected ? 0 : -1,
        children: type.title
      }, type.id);
    })
  });
};

Header.defaultProps = {
  active: REVIEWS
};
Header.propTypes = {
  active: PropTypes.shape(),
  setActive: PropTypes.func
};
export default Header;